// src/data/programOutcomes.js

export const programOutcomes = [
  {
    slug: "digital-marketing-mentorship-program",
    introduction:
      "The program offers a comprehensive introduction to Digital marketing, designed to equip participants with essential skills and practical knowledge through interactive learning experiences, real-world projects, and expert guidance.",
    outcomes: [
      "Develop a strong understanding of digital marketing principles.",
      "Gain practical knowledge through hands-on projects and case studies.",
      "Learn to create effective digital marketing strategies and campaigns.",
      "Master techniques for conducting market research and analyzing consumer needs.",
      "Understand the digital marketing ecosystem and tools.",
      "Enhance skills in data analysis and performance measurement.",
      "Acquire the ability to launch and manage successful digital marketing campaigns.",
      "Receive a certification upon successful course completion to enhance career prospects.",
    ],
    tools: [
      "Google trends",
      "Google Ads Manager",
      "Google Tag Manager",
      "Microsoft Clarity",
      " Meta Ads Manager",
      "Make.com",
      "Chatgpt and Claude",
    ],
  },
  {
    slug: "performance-marketing-mentorship-program",
    introduction:
      "A 12-week Performance Marketing Mentorship Program is designed to equip individuals with the skills needed for success in performance marketing, focusing on results-driven strategies such as clicks, leads, and sales..",
    outcomes: [
      "Gain a solid foundation in performance marketing principles and audience targeting.",
      "Learn to craft high-converting ads and optimize ad copy, creatives, and funnels.",
      "Develop skills in advanced conversion tracking and analytics for data-driven insights.",
      "Master Google and Facebook Ads, including optimization and bidding strategies.",
      "Build expertise in media planning, buying, and alternative ad networks.",
      "Understand automation and attribution, including multi-touch and custom attribution models.",
      "Apply knowledge to real-world projects, preparing for roles in performance marketing and growth strategy.",
    ],
    tools: [
      "You can learn 100+ tools",
      "Freshworks CRM ,Hubspot, Semrush, Ahrefs, Linkedin Ads, Crystal.ai, Lusha, Google Analytics, Google Tag, GA360, Adobe Analytics ",
      "and many more.....",
    ],
  },
  {
    slug: "ui-ux-design-mentorship-program",
    introduction:
      "The program offers a comprehensive introduction to UX Design, designed to equip participants with essential skills and practical knowledge through interactive learning experiences, real-world projects, and expert guidance.",
    outcomes: [
      "Enhanced Skill Set Comprehensive understanding of UX design principles and practices.",
      "Practical Experience: Hands-on experience through real-world projects and case studies.",
      "Professional Portfolio: Creation of a professional portfolio to showcase UX design work.",
      "Industry Connections : Networking with industry professionals and mentors.",
      "Career Advancement : Skills and knowledge for career advancement in UX design.",
    ],
    tools: [
      "Meero",
      "Notion",
      "Figma",
      "Lottie Files",
      "Behance",
      "Framer",
      "Medium",
      "Uizard",
      "Designs.ai",
      "Galileo",
      "Lookback",
      "UserZoom",
      "Qualtircs.XM",
      "Hotjar",
      "Figjam",
      "Remesh",
    ],
  },
  {
    slug: "product-management-mentorship-program",
    introduction:
      "End-to-End Product Development Skills: Gain hands-on experience in product management, including defining product roadmaps, ideating new product features, and managing product lifecycles.",
    outcomes: [
      "Market and User Research Proficiency: Develop the ability to conduct in-depth user and market research to understand customer needs, market gaps, and competitor landscapes.",
      "Strategic Decision-Making Skills: Build strong analytical skills to make data-driven decisions, assess product-market fit, and prioritize features based on user feedback and company goals.",
      "Cross-Functional Leadership: Learn to lead cross-functional teams and collaborate with designers, engineers, and marketing teams to bring products to life.",
      "Business and Financial Acumen: Develop a keen understanding of product-related business metrics, financial implications, and key performance indicators (KPIs) critical for driving product success.",
      "Project Management Expertise: Master tools and techniques for managing projects, timelines, and resources effectively, ensuring timely delivery and quality outcomes.",
      "Enhanced Communication and Presentation Skills: Strengthen skills in presenting ideas, pitching to stakeholders, and effectively communicating product visions and strategies.",
      "Practical Application of Tools and Frameworks: Get proficient in industry-standard tools like JIRA, Figma, and others, along with frameworks such as Agile, Lean, and Design Thinking.",
      "Capstone Project for Portfolio: Complete a capstone project that demonstrates your ability to manage a product from conception to execution, adding a valuable piece to your professional portfolio.",
      "Networking and Industry Insights: Access to a network of mentors, industry experts, and fellow product managers, providing insights into the latest trends and best practices in product management.",
    ],
    tools: [
      "User Testing",
      "Mixpanel",
      "Figma",
      "Miro",
      "Balsamiq",
      "Microsoft Clarity",
      "Any Do",
      "Jira",
      "GA",
    ],
  },
  {
    slug: "management-consulting-mentorship-program",
    introduction:
      "Gain a thorough understanding of the consulting industry, its diverse career trajectories, necessary skills, and the inner workings of consulting firms. This knowledge will empower you to make well-informed decisions about your potential engagement in this field.",
    outcomes: [
      "Master AI-powered consulting workflows and automation tools to become a T-Shaped Consultant who combines traditional problem-solving with cutting-edge efficiency.",
      "Understand the role, functions, and daily activities of consultants",
      "Explore diverse career paths and strategies to overcome entry barriers",
      "Gain insights into prominent consulting firms and their hiring processes",
      "Identify key skills, opportunities, and recent industry trends",
      "Discover various consulting practice types and their workflow",
      "Engage in real-life case studies and self-assessment sessions",
    ],
    tools: [
      "AI Mock Interview tool",
      "AI Resume Optimization tool",
      "AI LinkedIn Review tool",
      "AI cover Letter Review tool",
      "Emily AI",
      "Simplified AI",
      "PLSFIX PPT Slides",
      "Make.com",
    ],
  },
  {
    slug: "product-marketing-mentorship-program",
    introduction:
      "The key outcome for self-paced product marketing is to gain a comprehensive understanding of product marketing principles, metrics, and strategies, enabling effective positioning and demand generation. This curriculum includes:",
    outcomes: [
      "Learn how to develop impactful go-to-market strategies.",
      "Gain the ability to craft compelling product narratives that resonate with your target audience.",
      "Understand customer behavior and use insights to shape marketing strategies.",
      "Master the art of product positioning and pricing to enhance market competitiveness.",
      "Build expertise in leveraging digital tools and analytics for product marketing success.",
    ],
    tools: [],
  },
  {
    slug: "workshops/linkedin-growth",
    introduction:
      "Master LinkedIn marketing strategies to build your personal brand, generate quality leads, and drive business growth through strategic networking and content creation techniques.",
    outcomes: [
      "Want to build a personal brand but don’t know where to start",
      "Get inbound offers from recruiters and clients",
      "Get top quality leads without spending a dollar in ads",
      "Leverage the power of LinkedIn but don't know where to get started",
      "Reach more people organically but are failing to do so",
      "Generate leads for your business but don’t know ‘how’"
    ],
    tools: [
      "ChatGPT",
      "Humata",
      "Copilot",
      "Perplexity",
      "curata",
      "vaizl",
      "Heygen"
     
    ],
  },
  {
    slug: "workshops/chatgpt-workshop",

    introduction:
      "Master generative AI and ChatGPT to enhance productivity, accelerate career growth, and transform your business operations through practical AI applications focused on real-world results.",
    outcomes: [
      "Learn the 'Magic Prompt Formula' to consistently get optimal outputs from ChatGPT",
      "Create high-converting marketing copy and generate creative content ideas",
      "Analyze large datasets quickly and extract meaningful business insights",
      "Build personalized AI-powered communication systems for customer engagement",
      "Implement AI automation for tedious tasks to save hours of work weekly",
      "Understand ChatGPT's limitations and learn when not to rely on AI tools",
      "Develop domain-specific AI strategies for your professional field",
    ],
    tools: [
      "ChatGPT",
      "Descript",
      "HeyGen",
      "Tome",
      "DId",
      "Vidyo.ai",
      "Opus Clip",
      "Invideo",
      "Midjourney",
      "Engage",
      "Humata",
      "Simplified",
      "Underduck",
      "Feedly",
      "Compose ai",
      "claude"
    ],
  },
   {
    slug: "workshops/ai-for-consultants",
    introduction: "Master AI technologies and strategies specifically designed for consulting professionals to enhance strategic decision-making, automate routine tasks, derive advanced insights from complex data, and deliver superior client value in today's AI-driven business landscape.",
  outcomes: [
    "Develop advanced AI prompt engineering skills tailored for consulting deliverables and client communications",
    "Leverage AI for efficient data analysis and extracting actionable insights from large datasets",
    "Create compelling consulting proposals and presentations using AI-enhanced tools",
    "Implement AI-driven strategic planning methodologies for more accurate forecasting",
    "Automate routine consulting tasks to focus on high-value strategy and client engagement",
    "Apply AI techniques for competitive intelligence and market research",
    "Integrate AI tools into existing consulting workflows and methodologies"
  ],
  tools: [
    "ChatGPT with specialized consulting prompts",
    "AI data analysis platforms",
    "Presentation and slide deck automation tools",
    "Strategic decision-making AI assistants",
    "Client proposal generation systems",
    "Market research and competitive analysis AI",
    "Project management automation tools",
    "Financial modeling and forecasting AI",
    "Client communication enhancement tools",
    "Document analysis and summarization software"
  ]
  },
      {
    slug: "workshops/product-management",
  introduction: "Master the core principles and practical skills of product management through a comprehensive learning journey covering the entire product lifecycle, from ideation to launch, led by experienced product leaders from top tech companies.",
  outcomes: [
    "Develop a strategic mindset for identifying market opportunities and customer pain points",
    "Create effective product documentation including PRDs, user stories, and roadmaps",
    "Master prioritization frameworks to make data-driven product decisions",
    "Understand UI/UX fundamentals and create wireframes and prototypes",
    "Learn technical concepts including APIs, system architecture, and AI/no-code development",
    "Gain proficiency in product analytics, SQL, and measuring product success metrics",
    "Build collaboration skills for working effectively with designers, engineers, and stakeholders",
    "Apply Agile/Scrum methodologies to manage product development cycles",
    "Create and execute product marketing and go-to-market strategies"
  ],
  tools: [
    "Wireframing and prototyping tools",
    "SQL and data analytics platforms",
    "Product documentation templates and frameworks",
    "Agile project management software",
    "User research and testing platforms",
    "Prioritization frameworks and templates",
    "Product roadmapping tools",
    "Customer journey mapping software",
    "A/B testing and experimentation platforms",
    "No-code development environments"
  ]
  },
           {
    slug: "workshops/business-mastermind",
  introduction: "Master the core principles and practical skills of product management through a comprehensive learning journey covering the entire product lifecycle, from ideation to launch, led by experienced product leaders from top tech companies.",
  outcomes: [
    "Develop a strategic mindset for identifying market opportunities and customer pain points",
    "Create effective product documentation including PRDs, user stories, and roadmaps",
    "Master prioritization frameworks to make data-driven product decisions",
    "Understand UI/UX fundamentals and create wireframes and prototypes",
    "Learn technical concepts including APIs, system architecture, and AI/no-code development",
    "Gain proficiency in product analytics, SQL, and measuring product success metrics",
    "Build collaboration skills for working effectively with designers, engineers, and stakeholders",
    "Apply Agile/Scrum methodologies to manage product development cycles",
    "Create and execute product marketing and go-to-market strategies"
  ],
  tools: [
    "Apollo.io",
    "N8n",
    "Make.com",
    "ChatGPT",
    "Perplexity",
    "Midjourney",
    "Runway",
    "Notion",
    "Writesonic",

  ]
  },
                  {
    slug: "workshops/marketing-mastermind",
  introduction: "Master the core principles and practical skills of product management through a comprehensive learning journey covering the entire product lifecycle, from ideation to launch, led by experienced product leaders from top tech companies.",
  outcomes: [
    "Develop a strategic mindset for identifying market opportunities and customer pain points",
    "Create effective product documentation including PRDs, user stories, and roadmaps",
    "Master prioritization frameworks to make data-driven product decisions",
    "Understand UI/UX fundamentals and create wireframes and prototypes",
    "Learn technical concepts including APIs, system architecture, and AI/no-code development",
    "Gain proficiency in product analytics, SQL, and measuring product success metrics",
    "Build collaboration skills for working effectively with designers, engineers, and stakeholders",
    "Apply Agile/Scrum methodologies to manage product development cycles",
    "Create and execute product marketing and go-to-market strategies"
  ],
  tools: [
   "Apollo.io",
    "N8n",
    "Make.com",
    "Chatsimple",
     "ChatGPT",
    "Perplexity",
    "Midjourney",
    "Runway",
    "MagicPost",
    "Canva",
    "Involve.me",
    "Gamma",
    "Agentive",
    "Gemini",
    "Deepseek",
    "Looker Studio"
  ]
  },
];

export default programOutcomes;
